// frontend/src/config.js

// No navegador, a URL do backend é relativa ou a mesma origem
export const getBackendUrl = () => {
    return window.location.origin; 
};

// Para o Socket, usamos a mesma origem
export const getSocketUrl = () => {
    return window.location.origin; 
};